import React, { useState } from "react";
import "./Checklist5R.css";
import { useChecklist5R } from "./useChecklist5R.js";
import FormChecklist5R from "../../components/FormChecklist5R/FormChecklist5R";

const Checklist5R = () => {
  const {
    dataUser,
    loading,
    loadingData,
    loadedChecklist,
    loadedOperators,
    fetchVersion,
    defaultBulan,
    defaultTahun,
    fetchChecklist,
    submitChecklist,
  } = useChecklist5R();

  const [selectedHeader, setSelectedHeader] = useState({
    tim: "1",
    mesin: "",
    bulan: defaultBulan,
    tahun: defaultTahun,
  });

  const handleHeaderChange = (header) => {
    setSelectedHeader(header);
    fetchChecklist(header);
  };

  const formKey = `${selectedHeader.tim}-${selectedHeader.mesin}-${selectedHeader.bulan}-${selectedHeader.tahun}-${fetchVersion}`;

  const lockedShiftCells = loadedChecklist
    .filter((item) => item?.value !== null && item?.value !== undefined)
    .map((item) => `${item.tanggal}-${item.shift}`);

  return (
    <div className="container_dashboard">
      {loadingData && <p>Memuat data checklist...</p>}

      <FormChecklist5R
        key={formKey}
        tim={selectedHeader.tim}
        mesin={selectedHeader.mesin}
        bulanValue={selectedHeader.bulan}
        tahunValue={selectedHeader.tahun}
        data={loadedChecklist}
        operatorData={loadedOperators}
        currentUserName={dataUser?.name}
        onHeaderChange={handleHeaderChange}
        onSubmit={submitChecklist}
        readOnly={loading}
        lockedShiftCells={lockedShiftCells}
      />
    </div>
  );
};

export default Checklist5R;
